// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"c2bd2b14","315":"b9334f93","453":"cd0aaa87","797":"46d1f3e8"}[chunkId] + ".chunk.js";
};